/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Enum for AIFreedback rating types
 */
export type AIFeedbackRatingType = typeof AIFeedbackRatingType[keyof typeof AIFeedbackRatingType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AIFeedbackRatingType = {
  thumbs: 'thumbs',
  stars: 'stars',
} as const;
